/* eslint-disable no-param-reassign */
import produce from 'immer';
import { endTaskDialogInitialState } from '../../constants';

const SET_DATA = 'SET_DATA';
const SET_CLOSED_TASK_USED_MATERIALS = 'SET_CLOSED_TASK_USED_MATERIALS';
const SET_NEW_USED_MATERIALS = 'SET_NEW_USED_MATERIALS';
const SET_MATERIALS_DIALOG = 'SET_MATERIALS_DIALOG';
const SET_RETURN_MATERIALS_DIALOG = 'SET_RETURN_MATERIALS_DIALOG';
const SET_RETURNED_MATERIALS = 'SET_RETURNED_MATERIALS';
const SET_MATERIAL_SELL_DIALOG = 'SET_MATERIAL_SELL_DIALOG';
const SET_SHOW_TASK_DETAILS = 'SET_SHOW_TASK_DETAILS';
const SET_TASK_STARTED = 'SET_TASK_STARTED';
const SET_CONFIRMATION_DIALOG = 'SET_CONFIRMATION_DIALOG';
const SET_SNACKBAR = 'SET_SNACKBAR';
const SET_END_TASK_DIALOG = 'SET_END_TASK_DIALOG';
const OPEN_END_TASK_DIALOG = 'OPEN_END_TASK_DIALOG';
const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
const SET_USED_MATERIALS_DIALOG = 'SET_USED_MATERIALS_DIALOG';
const SET_ITS_MATERIAL_DIALOG = 'SET_ITS_MATERIAL_DIALOG';
const SET_TASK_UPDATED = 'SET_TASK_UPDATED';
const SET_TASK_VERIFY_ADDRESS = 'SET_TASK_VERIFY_ADDRESS';
const PUSH_DEBUG_LOG = 'PUSH_DEBUG_LOG';
const SET_AUTOMATIC_TEST_CLOSE_REASONS = 'SET_AUTOMATIC_TEST_CLOSE_REASONS';
const SET_AUTOMATIC_TEST_RESULTS = 'SET_AUTOMATIC_TEST_RESULTS';
const SET_REJECT_SIGNATURE_REQUEST_DIALOG = 'SET_REJECT_SIGNATURE_REQUEST_DIALOG';
const UPDATE_MATERIALS_TO_SELL = 'UPDATE_MATERIALS_TO_SELL';
const SET_SAP_MATERIALS = 'SET_SAP_MATERIALS';
const SIGNED_TECHNICIANS = 'SIGNED_TECHNICIANS';
const CREATE_PIN_DIALOG = 'CREATE_PIN_DIALOG';
const CONFIRM_MATERIALS_DIALOG = 'CONFIRM_MATERIALS_DIALOG';
const SET_CONFIRM_MATERIALS = 'SET_CONFIRM_MATERIALS';
const RESET_PASSWORD_ANDROID_BOX = 'RESET_PASSWORD_ANDROID_BOX';
const SHOW_CLOSE_REASONS = 'SHOW_CLOSE_REASONS';

const setNewUsedMaterials = payload => ({
  type: SET_NEW_USED_MATERIALS,
  payload,
});
const setClosedTaskUsedMaterials = payload => ({
  type: SET_CLOSED_TASK_USED_MATERIALS,
  payload,
});
const setData = payload => ({
  type: SET_DATA,
  payload,
});
const setMaterialsDialog = payload => ({
  type: SET_MATERIALS_DIALOG,
  payload,
});
const setReturnMaterialsDialog = payload => ({
  type: SET_RETURN_MATERIALS_DIALOG,
  payload,
});
const setReturnedMaterials = payload => ({
  type: SET_RETURNED_MATERIALS,
  payload,
});
const setMaterialSellDialog = payload => ({
  type: SET_MATERIAL_SELL_DIALOG,
  payload,
});
const setShowTaskDetails = payload => ({
  type: SET_SHOW_TASK_DETAILS,
  payload,
});
const setTaskStarted = payload => ({
  type: SET_TASK_STARTED,
  payload,
});
const setConfirmationDialog = payload => ({
  type: SET_CONFIRMATION_DIALOG,
  payload,
});
const setSnackbar = payload => ({
  type: SET_SNACKBAR,
  payload,
});
const setEndTaskDialog = payload => ({
  type: SET_END_TASK_DIALOG,
  payload,
});
const openEndTaskDialog = payload => ({
  type: OPEN_END_TASK_DIALOG,
  payload,
});
const setNotifications = payload => ({
  type: SET_NOTIFICATIONS,
  payload,
});
const setUsedMaterialsDialog = payload => ({
  type: SET_USED_MATERIALS_DIALOG,
  payload,
});
const setItsMaterialDialog = payload => ({
  type: SET_ITS_MATERIAL_DIALOG,
  payload,
});
const setTaskUpdated = payload => ({
  type: SET_TASK_UPDATED,
  payload,
});
const setTaskVerifyAddress = payload => ({
  type: SET_TASK_VERIFY_ADDRESS,
  payload,
});
const pushDebugLog = payload => ({
  type: PUSH_DEBUG_LOG,
  payload,
});
const setAutomaticTestCloseReasons = payload => ({
  type: SET_AUTOMATIC_TEST_CLOSE_REASONS,
  payload,
});
const setAutomaticTestResults = payload => ({
  type: SET_AUTOMATIC_TEST_RESULTS,
  payload,
});

const createPinDialog = payload => ({
  type: CREATE_PIN_DIALOG,
  payload,
});

const setRejectSignatureRequestDialog = payload => ({
  type: SET_REJECT_SIGNATURE_REQUEST_DIALOG,
  payload,
});

const updateMaterialsToSell = payload => ({
  type: UPDATE_MATERIALS_TO_SELL,
  payload,
});

const setSapMaterials = payload => ({
  type: SET_SAP_MATERIALS,
  payload,
});

const signedTechnicians = payload => ({
  type: SIGNED_TECHNICIANS,
  payload,
});
const confirmMaterialsDialog = payload => ({
  type: CONFIRM_MATERIALS_DIALOG,
  payload,
});

const setConfirmMaterials = payload => ({
  type: SET_CONFIRM_MATERIALS,
  payload,
});

const resetPasswordAndroidBox = payload => ({
  type: RESET_PASSWORD_ANDROID_BOX,
  payload,
});

const ticketTypesCloseReasons = payload => ({
  type: SHOW_CLOSE_REASONS,
  payload,
});

const reducer = (
  state = {
    data: {
      canExecuteManualTest: true,
      scheduleByDate: null,
      materials: [],
      tools: [],
      usedMaterials: [],
      sellMaterials: [],
      tasks: [],
      loaded: false,
      isCpeReturnLoading: false,
      processedOldDevices: [],
      devicesWithBadIndicators: [],
      confirmMaterials: [],
      ticketTypesCloseReasons: [],
      isReturnMaterialByQuantityLoading: false,
      isReturnToWarehouseLoading: false,
    },
    newUsedMaterials: [],
    returnedMaterials: [],
    closedTaskUsedMaterials: [],
    materialsDialog: {
      open: false,
      dataSet: '',
      checkout: false,
      hideDismantledMaterials: false,
    },
    itsMaterialDialog: {
      open: false,
      dataSet: '',
      checkout: false,
      isInstaledMaterials: false,
    },
    materialSellDialog: {
      open: false,
      readonly: false,
      taskId: undefined,
    },
    returnMaterialsDialog: {
      open: false,
    },
    showTaskDetails: {
      open: false,
      taskId: null,
    },
    taskStarted: { started: false, taskId: null },
    confirmationDialog: {
      open: false,
      title: [],
      onConfirm: null,
      onCancel: null,
    },
    snackbar: { open: false, message: null },
    chechedMaterialsToSell: [],
    endTaskDialog: endTaskDialogInitialState,
    notifications: { open: false, list: [], seen: true },
    usedMaterialsDialog: { open: false },
    taskUpdated: { taskId: null },
    taskVerifyAddress: false,
    automaticTestCloseReasons: [],
    automaticTestResults: [],
    debugLog: [],
    signedTechnicians: { show: false, technicians: [] },
    rejectSignatureRequestDialog: {
      open: false,
      title: [],
      onConfirm: null,
      onCancel: null,
      rejectSignatureRequestReasonId: null,
      rejectSignatureRequestNote: null,
    },
    sapMaterials: undefined,
    createPinDialog: false,
    confirmMaterialsDialog: false,
    resetPasswordAndroidBox: { open: false, houseHoldId: null },
  },
  action
) =>
  produce(state, draft => {
    switch (action.type) {
      case SET_DATA:
        draft.data = action.payload;
        break;
      case SET_NEW_USED_MATERIALS:
        draft.newUsedMaterials = action.payload;
        break;
      case SET_CLOSED_TASK_USED_MATERIALS:
        draft.closedTaskUsedMaterials = action.payload;
        break;
      case SET_MATERIALS_DIALOG:
        draft.materialsDialog = action.payload;
        break;
      case SET_RETURN_MATERIALS_DIALOG:
        draft.returnMaterialsDialog = action.payload;
        break;
      case SET_RETURNED_MATERIALS:
        draft.returnedMaterials = action.payload;
        break;
      case SET_MATERIAL_SELL_DIALOG:
        draft.materialSellDialog = action.payload;
        break;
      case SET_SHOW_TASK_DETAILS:
        draft.showTaskDetails = action.payload;
        break;
      case SET_TASK_STARTED:
        draft.taskStarted = action.payload;
        break;
      case SET_CONFIRMATION_DIALOG:
        draft.confirmationDialog = action.payload;
        break;
      case SET_SNACKBAR:
        draft.snackbar = action.payload;
        break;
      case SET_NOTIFICATIONS:
        draft.notifications = action.payload;
        break;
      case SET_USED_MATERIALS_DIALOG:
        draft.usedMaterialsDialog = action.payload;
        break;
      case SET_ITS_MATERIAL_DIALOG:
        draft.itsMaterialDialog = action.payload;
        break;
      case SET_END_TASK_DIALOG:
        draft.endTaskDialog = action.payload;
        break;
      case OPEN_END_TASK_DIALOG:
        draft.endTaskDialog.open = action.payload.open;
        draft.endTaskDialog.taskId = action.payload.taskId;
        break;
      case SET_TASK_UPDATED:
        draft.taskUpdated = action.payload;
        break;
      case SET_TASK_VERIFY_ADDRESS:
        draft.taskVerifyAddress = action.payload;
        break;
      case PUSH_DEBUG_LOG: {
        const updatedDebugLog = [...draft.debugLog];
        updatedDebugLog.push(action.payload);
        draft.debugLog = updatedDebugLog;
        break;
      }
      case SET_AUTOMATIC_TEST_CLOSE_REASONS: {
        draft.automaticTestCloseReasons = action.payload;
        break;
      }
      case SET_AUTOMATIC_TEST_RESULTS: {
        draft.automaticTestResults = action.payload;
        break;
      }
      case SET_REJECT_SIGNATURE_REQUEST_DIALOG: {
        draft.rejectSignatureRequestDialog = action.payload;
        break;
      }
      case UPDATE_MATERIALS_TO_SELL: {
        draft.chechedMaterialsToSell = action.payload;
        break;
      }
      case SET_SAP_MATERIALS: {
        draft.sapMaterials = action.payload;
        break;
      }
      case SIGNED_TECHNICIANS: {
        draft.signedTechnicians = action.payload;
        break;
      }
      case CREATE_PIN_DIALOG: {
        draft.createPinDialog = action.payload;
        break;
      }
      case CONFIRM_MATERIALS_DIALOG: {
        draft.confirmMaterialsDialog = action.payload;
        break;
      }
      case SET_CONFIRM_MATERIALS: {
        draft.data.confirmMaterials = action.payload;
        break;
      }
      case RESET_PASSWORD_ANDROID_BOX: {
        draft.resetPasswordAndroidBox = action.payload;
        break;
      }
      case SHOW_CLOSE_REASONS: {
        draft.ticketTypesCloseReasons = action.payload;
        break;
      }

      default:
        break;
    }
  });

export {
  reducer,
  setNewUsedMaterials,
  setClosedTaskUsedMaterials,
  setData,
  setMaterialsDialog,
  setReturnMaterialsDialog,
  setReturnedMaterials,
  setMaterialSellDialog,
  setShowTaskDetails,
  setTaskStarted,
  setConfirmationDialog,
  setSnackbar,
  setEndTaskDialog,
  setNotifications,
  setUsedMaterialsDialog,
  setTaskUpdated,
  setTaskVerifyAddress,
  pushDebugLog,
  openEndTaskDialog,
  setAutomaticTestCloseReasons,
  setAutomaticTestResults,
  setRejectSignatureRequestDialog,
  updateMaterialsToSell,
  setSapMaterials,
  signedTechnicians,
  createPinDialog,
  confirmMaterialsDialog,
  setConfirmMaterials,
  setItsMaterialDialog,
  resetPasswordAndroidBox,
  ticketTypesCloseReasons,
};
